<template>
    <m-control
        type="radio"
        label="Wersja EKO"
        name="eko_version"
        v-model="ekoStatus"
        :items="ekoStatusTypes"
    />
</template>

<script>
export default {
    data() {
        return {
            ekoStatusTypes: [
                {
                    value: '1',
                    label: 'tak'
                },
                {
                    value: '0',
                    label: 'nie'
                }
            ]
        }
    },
    computed: {
        ekoStatus: {
            get() {
                return this.$store.getters['eko/status']
            },
            set() {
                this.$store.dispatch('eko/changeStatus')
            }
        }
    }
}
</script>

<style>
</style>